export default __webpack_public_path__ + "static/media/civil-society-and-eu.2290e4f2.svg";